"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _UICoreBlazeSlider_instances, _UICoreBlazeSlider_breakpointMap, _UICoreBlazeSlider_configBuilderObject, _UICoreBlazeSlider_defineSlider, _UICoreBlazeSlider_mergeObjects, _UICoreBlazeSlider_getConfigObject, _UICoreBlazeSlider_getValueReturnType, _UICoreBlazeSlider_validateAttributeSegments, _UICoreBlazeSlider_getConfigKey;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UICoreBlazeSlider = void 0;
const blaze_slider_esm_1 = __importDefault(require("@flashpointbv/blaze-slider/dist/blaze-slider.esm"));
require("@flashpointbv/blaze-slider/dist/blaze.css");
class UICoreBlazeSlider {
    constructor(config) {
        _UICoreBlazeSlider_instances.add(this);
        _UICoreBlazeSlider_breakpointMap.set(this, Object.freeze({
            mobile: 'all',
            tablet: UICoreBlazeSlider.breakPointKeys['tabletBreakpoint'],
            desktop: UICoreBlazeSlider.breakPointKeys['desktopBreakpoint'],
        }));
        _UICoreBlazeSlider_configBuilderObject.set(this, {
            all: {},
            [UICoreBlazeSlider.breakPointKeys['tabletBreakpoint']]: {},
            [UICoreBlazeSlider.breakPointKeys['desktopBreakpoint']]: {}
        });
        const defaultConfig = Object.assign(Object.assign({}, UICoreBlazeSlider.config), config);
        document.addEventListener('DOMContentLoaded', () => {
            const sliderElements = document.querySelectorAll('.blaze-slider');
            sliderElements.forEach((slider) => {
                __classPrivateFieldGet(this, _UICoreBlazeSlider_instances, "m", _UICoreBlazeSlider_defineSlider).call(this, slider);
            });
        });
    }
}
exports.UICoreBlazeSlider = UICoreBlazeSlider;
_UICoreBlazeSlider_breakpointMap = new WeakMap(), _UICoreBlazeSlider_configBuilderObject = new WeakMap(), _UICoreBlazeSlider_instances = new WeakSet(), _UICoreBlazeSlider_defineSlider = function _UICoreBlazeSlider_defineSlider(sliderEl) {
    const mergedConfigurations = __classPrivateFieldGet(this, _UICoreBlazeSlider_instances, "m", _UICoreBlazeSlider_mergeObjects).call(this, UICoreBlazeSlider.blazeConfig, __classPrivateFieldGet(this, _UICoreBlazeSlider_instances, "m", _UICoreBlazeSlider_getConfigObject).call(this, sliderEl));
    new blaze_slider_esm_1.default(sliderEl, mergedConfigurations);
}, _UICoreBlazeSlider_mergeObjects = function _UICoreBlazeSlider_mergeObjects(obj1, obj2) {
    let merged = Object.assign(Object.assign({}, obj1), obj2);
    for (let [key, value] of Object.entries(merged)) {
        if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
            merged[key] = __classPrivateFieldGet(this, _UICoreBlazeSlider_instances, "m", _UICoreBlazeSlider_mergeObjects).call(this, obj1[key], obj2[key]);
        }
    }
    return merged;
}, _UICoreBlazeSlider_getConfigObject = function _UICoreBlazeSlider_getConfigObject(sliderEl) {
    const elementAttributes = sliderEl.getAttributeNames();
    let configObject = __classPrivateFieldGet(this, _UICoreBlazeSlider_configBuilderObject, "f");
    elementAttributes.forEach((attribute) => {
        if (attribute.indexOf('data') === 0) {
            const attributeSegments = attribute.split('-');
            if (__classPrivateFieldGet(this, _UICoreBlazeSlider_instances, "m", _UICoreBlazeSlider_validateAttributeSegments).call(this, attributeSegments)) {
                const breakpointKey = attributeSegments[1];
                const configKey = __classPrivateFieldGet(this, _UICoreBlazeSlider_instances, "m", _UICoreBlazeSlider_getConfigKey).call(this, attributeSegments);
                const configValue = sliderEl.getAttribute(attribute);
                configObject[__classPrivateFieldGet(this, _UICoreBlazeSlider_breakpointMap, "f")[breakpointKey]][configKey] = __classPrivateFieldGet(this, _UICoreBlazeSlider_instances, "m", _UICoreBlazeSlider_getValueReturnType).call(this, configValue);
            }
        }
    });
    return configObject;
}, _UICoreBlazeSlider_getValueReturnType = function _UICoreBlazeSlider_getValueReturnType(value = '') {
    if (value === 'true')
        return true;
    if (value === 'false')
        return false;
    if (value === 'null')
        return null;
    if (value === 'undefined')
        return undefined;
    if (value === 'NaN')
        return NaN;
    if (!isNaN(Number(value)))
        return Number(value);
    return value;
}, _UICoreBlazeSlider_validateAttributeSegments = function _UICoreBlazeSlider_validateAttributeSegments(attributeSegments) {
    if (attributeSegments.length < 3) {
        console.debug('Invalid attribute segment length (3 minimum)');
        return false;
    }
    if (UICoreBlazeSlider.breakpointAttributeKeys.indexOf(attributeSegments[1]) === -1) {
        console.debug(`Invalid breakpoint attribute key "${attributeSegments[1]}"`);
        console.debug(`Valid breakpoint attribute keys: ${UICoreBlazeSlider.breakpointAttributeKeys.join(', ')}`);
        return false;
    }
    return true;
}, _UICoreBlazeSlider_getConfigKey = function _UICoreBlazeSlider_getConfigKey(attributeSegments) {
    return attributeSegments.slice(2).map((segment, index) => index > 0
        ? `${segment.charAt(0).toUpperCase()}${segment.slice(1)}`
        : segment)
        .join('');
};
UICoreBlazeSlider.breakpointAttributeKeys = [
    'mobile',
    'tablet',
    'desktop',
];
UICoreBlazeSlider.config = {
    tabletBreakpoint: 576,
    desktopBreakpoint: 920,
};
UICoreBlazeSlider.breakPointKeys = {
    tabletBreakpoint: `(min-width: ${UICoreBlazeSlider.config['tabletBreakpoint']}px)`,
    desktopBreakpoint: `(min-width: ${UICoreBlazeSlider.config['desktopBreakpoint']}px)`
};
UICoreBlazeSlider.blazeConfig = {
    all: {
        slidesToShow: 1,
        fixedSlides: true,
        loop: false,
        slideGap: '10px',
    },
    [UICoreBlazeSlider.breakPointKeys['tabletBreakpoint']]: {
        slidesToShow: 3,
    },
    [UICoreBlazeSlider.breakPointKeys['desktopBreakpoint']]: {
        slidesToShow: 4,
    },
};
